import "../chunk-5WRI5ZAA.js";

// src/types/types.ts
var ILivePreviewModeConfig = /* @__PURE__ */ ((ILivePreviewModeConfig2) => {
  ILivePreviewModeConfig2[ILivePreviewModeConfig2["PREVIEW"] = 1] = "PREVIEW";
  ILivePreviewModeConfig2[ILivePreviewModeConfig2["BUILDER"] = 2] = "BUILDER";
  return ILivePreviewModeConfig2;
})(ILivePreviewModeConfig || {});
var ILivePreviewWindowType = /* @__PURE__ */ ((ILivePreviewWindowType2) => {
  ILivePreviewWindowType2["PREVIEW"] = "preview";
  ILivePreviewWindowType2["BUILDER"] = "builder";
  ILivePreviewWindowType2["INDEPENDENT"] = "independent";
  return ILivePreviewWindowType2;
})(ILivePreviewWindowType || {});
export {
  ILivePreviewModeConfig,
  ILivePreviewWindowType
};
//# sourceMappingURL=types.js.map